/* eslint-disable */
import axios from "../../../shared/utils/axios-init";

/* eslint-disable */
const initialState = {
  passwordDialog: false,
  twoFactorAuthDialog: false,
  profile: {
    name: null,
    email: null,
    created: null,
    news: 1,
    auth: 1,
    outcome: 1,
    income: 1,
    twoStepsAuth: 0,
  },
  twoStepsAuthState: 0,
};

const getters = {
  passwordDialogState: (state) => state.passwordDialog,
  twoFactorAuthDialogState: (state) => state.twoFactorAuthDialog,
  getProfileData: (state) => state.profile,
  getTwoStepsAuthState: (state) => state.twoStepsAuthState,
};

const mutations = {
  togglePasswordDialog(state, dialogState) {
    state.passwordDialog = dialogState;
  },
  toggleTwoFactorAuthDialog(state, dialogState) {
    state.twoFactorAuthDialog = dialogState;
  },
  setProfileData(state, user) {
    state.profile.login = user.name;
    state.profile.email = user.email;
    state.profile.created = user.created_at;
    state.profile.news = +user.news_notif;
    state.profile.auth = +user.auth_notif;
    state.profile.outcome = +user.outcome_notif;
    state.profile.income = +user.income_notif;
    state.profile.twoStepsAuth = user.two_steps_auth;
  },
  toggleNotifications(state, payload) {
    state.profile[payload.type] = payload.state ? 1 : 0;
  },
  setTwoStepsAuthState(state, data) {
    state.twoStepsAuthState = data;
  },
};

const actions = {
  async fetchProfileData({ commit, rootState }) {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const data = await axios.post("/cabinet/info", null, {
        headers: { Authorization: `Bearer ${token}` },
      });

      commit("setProfileData", data.data.user);
      commit(
        "setTwoStepsAuthState",
        +rootState.account.profile.profile.twoStepsAuth
      );
    } catch (err) {
      console.log(err);
    }
  },
  async saveSettings({ state }) {
    const settings = {
      news_notif: state.profile.news,
      auth_notif: state.profile.auth,
      outcome_notif: state.profile.outcome,
      income_notif: state.profile.income,
      lang: localStorage.getItem("language"),
    };

    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const data = await axios.post(
        "/cabinet/info/save",
        JSON.stringify(settings),
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async changePassword({ commit, dispatch }, credentials) {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const data = await axios.post(
        "/cabinet/change-pass",
        JSON.stringify(credentials),
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async twoStepAuth({ commit, dispatch }, credentials) {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const data = await axios.post(
        "/cabinet/2-step-auth",
        JSON.stringify(credentials),
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/profile.js